import React from 'react';
import ReactDOM from 'react-dom';
import './style/index.css';
import App from './App';



/**
 * @file root folder of the application
 * @author Christelle Philippe
 * @see <a href="https://christelle74.github.io/PhilippeChristelle_12_SportSee/" target="_blank"> repo Git </a>
 */

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

